import { useQuery } from "@tanstack/react-query";
import { queries } from "../../queries";

export function useUser(userId: string, enabled: boolean = true) {
  const { data, isLoading, error } = useQuery({
    ...queries.user.getUser({userId}),
    enabled,
  });

  return { data, isLoading, error };
}
